import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-twig",
  "use": "icon-twig-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-twig\"><path fill=\"#333333\" d=\"M928.768 946.176c-58.368-501.76 66.56-367.616 66.56-367.616-137.216-161.792-205.824 7.168-239.616 165.888-16.384-253.952-94.208-673.792-410.624-666.624 171.008 0 181.248 345.088 163.84 592.896C360.448 408.576 28.672 429.056 28.672 429.056s249.856-10.24 249.856 517.12h650.24z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol